import {
  PRODUCTS_LIST_SORT_OPTIONS,
  type ProductsListSortOption,
} from '@up2stay/up2promo-commons/products';
import { ListSortSelect } from '@/core/components/layout';

export type ProductsListSortLabels = {
  sort: string;
  options: Record<ProductsListSortOption, string>;
};

type ProductsListSortSelectProps = {
  value: ProductsListSortOption;
  onChange: (next: ProductsListSortOption) => void;
  labels: ProductsListSortLabels;
};

export function ProductsListSortSelect({
  value,
  onChange,
  labels,
}: ProductsListSortSelectProps) {
  return (
    <ListSortSelect
      value={value}
      onChange={onChange}
      ariaLabel={labels.sort}
      triggerClassName="flex-1 sm:w-[13rem] sm:flex-none sm:shrink-0"
      options={PRODUCTS_LIST_SORT_OPTIONS.map((option) => ({
        value: option,
        label: labels.options[option],
      }))}
    />
  );
}
